import React from 'react';
import { DIFFERENTIATORS, STATS } from '../data/site';
import { Icon } from '../utils/icons';
import { SectionHeading } from './SectionHeading';
import { Reveal } from './Reveal';
export function Differentiators() {
  return <section className="bg-white py-24 sm:py-32 lg:py-40" data-id="element-96" data-mp="1r583levfaylf">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-97" data-mp="1w2qfne4qltxn">
        <Reveal data-id="element-98" data-mp="1w28att40e7e4">
          <SectionHeading eyebrow="Diferenciales" title={<>
                ¿Por qué <span className="text-brand" data-id="element-100" data-mp="13ecit1pdx3no">Silver Hogar</span>?
              </>} description="Seis razones por las que las familias vuelven, nos recomiendan y nos eligen de nuevo años después." align="center" data-id="element-99" data-mp="1w4uirtutaowv" />
        </Reveal>

        <div className="mt-14 grid gap-px overflow-hidden rounded-4xl border border-black/5 bg-black/5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-101" data-mp="1ddtj13lvapc9">
          {DIFFERENTIATORS.map((item, i) => <Reveal key={item.title} delay={i % 3 * 0.08} data-id="element-102" data-mp="2oq474wpo1xad" data-mpi={i}>
              <article className="group h-full bg-white p-8 sm:p-10 transition-colors duration-300 hover:bg-haze" data-id="element-103" data-mp="bpc9391ii1j2">
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-light text-brand transition-all duration-300 group-hover:bg-brand group-hover:text-white" data-id="element-104" data-mp="7oaa8tbibrhm">
                  <Icon name={item.icon} className="h-6 w-6" data-id="element-105" data-mp="3ttdvc3480mr7" />
                </span>
                <h3 className="mt-6 text-lg font-semibold text-ink" data-id="element-106" data-mp="3ovvxp8vnltyi">{item.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-ink-soft" data-id="element-107" data-mp="3k4w001epn7uy">{item.text}</p>
              </article>
            </Reveal>)}
        </div>

        <div className="mt-16 grid gap-10 rounded-4xl bg-haze px-8 py-12 sm:grid-cols-2 sm:px-12 lg:grid-cols-4 lg:py-16" data-id="element-108" data-mp="3g3afpuzujraq">
          {STATS.map((stat, i) => <Reveal key={stat.label} delay={i * 0.08} data-id="element-109" data-mp="3654g5k1iix91" data-mpi={i}>
              <div className="text-center lg:text-left" data-id="element-110" data-mp="366p9x7g06c5u">
                <p className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-ink" data-id="element-111" data-mp="3172viuofupvg">
                  {stat.value}
                </p>
                <p className="mt-3 text-sm sm:text-base text-ink-soft" data-id="element-112" data-mp="2wh8whha0sn5z">{stat.label}</p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}